var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVehicle = function SvgVehicle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.751,
    height: 24.539,
    viewBox: "0 0 30.751 24.539",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle",
    transform: "translate(-62.234 -640)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M4.416,313.222A4.416,4.416,0,1,0,7.3,320.987a.45.45,0,1,0-.588-.683,3.515,3.515,0,1,1,.809-1.008.45.45,0,0,0,.794.426A4.422,4.422,0,0,0,4.416,313.222Z",
    transform: "translate(62.234 342.485)",
    fill: "--es--svg--fill--transparent"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M39.144,350.169a2.2,2.2,0,1,0,2.2,2.2A2.2,2.2,0,0,0,39.144,350.169Zm0,3.494a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,39.144,353.663Z",
    transform: "translate(27.506 307.757)",
    fill: "--es--svg--fill--transparent"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M132.771,69.365a.45.45,0,0,0-.747.5,3.516,3.516,0,1,1-3.366-1.52v1.335a2.2,2.2,0,1,0,.9,0V68.349A3.5,3.5,0,0,1,131,68.87a.45.45,0,1,0,.485-.759,4.4,4.4,0,0,0-1.924-.669v-6.96h.746a.45.45,0,0,0,0-.9h-.746V53.3a1.585,1.585,0,0,0-1.584-1.584h-3.027a.45.45,0,1,0,0,.9h3.027a.684.684,0,0,1,.683.683v6.285h-.683a.45.45,0,0,0,0,.9h.683V63.84a8.346,8.346,0,0,0-6.377,4.995H113.1a6.155,6.155,0,0,0-3.135-2.962.45.45,0,1,0-.351.83,5.257,5.257,0,0,1,3.214,4.849.45.45,0,0,0,.45.45H122.2a.45.45,0,0,0,.45-.45,7.155,7.155,0,0,1,6.006-6.8v2.687a4.416,4.416,0,1,0,4.112,1.924ZM121.766,71.1h-8.05a6.192,6.192,0,0,0-.256-1.365h8.523A7.24,7.24,0,0,0,121.766,71.1Zm7.343,1.027a.45.45,0,0,0,.45-.45V70.621a1.3,1.3,0,1,1-.9,0v1.057A.45.45,0,0,0,129.109,72.128Z",
    transform: "translate(-40.54 588.288)",
    fill: "--es--svg--fill--transparent"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle.7f433474.svg";
export { ForwardRef as ReactComponent };